module.exports = __webpack_public_path__ + "static/media/190251640760856416.c8f19753.jpg";